import { enableCheats } from './Cheats';
import Game from './Game';
import { getGameConfig } from './GameConfig';
import Environment from './Utility/Environment';

if (process) {
    if (process.env.NODE_ENV === Environment.DEVELOPMENT) {
        enableCheats();
    }
}

getGameConfig().then(config => {
    return Game.init(config);
});
